import { __commonJS, __toESM } from "./chunk-B4qE4VCv.mjs";

//#region node_modules/.deno/@fastify+deepmerge@3.1.0/node_modules/@fastify/deepmerge/index.js
var require_deepmerge = /* @__PURE__ */ __commonJS({ "node_modules/.deno/@fastify+deepmerge@3.1.0/node_modules/@fastify/deepmerge/index.js": ((exports, module) => {
	const JSON_PROTO = Object.getPrototypeOf({});
	function defaultIsMergeableObjectFactory() {
		return function defaultIsMergeableObject(value) {
			return typeof value === "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
		};
	}
	function deepmergeConstructor(options) {
		function isNotPrototypeKey(value) {
			return value !== "constructor" && value !== "prototype" && value !== "__proto__";
		}
		function cloneArray(value) {
			let i = 0;
			const il = value.length;
			const result = new Array(il);
			for (; i < il; ++i) result[i] = clone(value[i]);
			return result;
		}
		function cloneObject(target) {
			const result = {};
			if (cloneProtoObject && Object.getPrototypeOf(target) !== JSON_PROTO) return cloneProtoObject(target);
			const targetKeys = getKeys(target);
			let i, il, key;
			for (i = 0, il = targetKeys.length; i < il; ++i) isNotPrototypeKey(key = targetKeys[i]) && (result[key] = clone(target[key]));
			return result;
		}
		function concatArrays(target, source) {
			const tl = target.length;
			const sl = source.length;
			let i = 0;
			const result = new Array(tl + sl);
			for (; i < tl; ++i) result[i] = clone(target[i]);
			for (i = 0; i < sl; ++i) result[i + tl] = clone(source[i]);
			return result;
		}
		const propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
		function getSymbolsAndKeys(value) {
			const result = Object.keys(value);
			const keys = Object.getOwnPropertySymbols(value);
			for (let i = 0, il = keys.length; i < il; ++i) propertyIsEnumerable.call(value, keys[i]) && result.push(keys[i]);
			return result;
		}
		const getKeys = options?.symbols ? getSymbolsAndKeys : Object.keys;
		const cloneProtoObject = typeof options?.cloneProtoObject === "function" ? options.cloneProtoObject : void 0;
		const isMergeableObject = typeof options?.isMergeableObject === "function" ? options.isMergeableObject : defaultIsMergeableObjectFactory();
		function isPrimitive(value) {
			return typeof value !== "object" || value === null;
		}
		const mergeArray = options && typeof options.mergeArray === "function" ? options.mergeArray({
			clone,
			deepmerge: _deepmerge$1,
			getKeys,
			isMergeableObject
		}) : concatArrays;
		function clone(entry) {
			return isMergeableObject(entry) ? Array.isArray(entry) ? cloneArray(entry) : cloneObject(entry) : entry;
		}
		function mergeObject(target, source) {
			const result = {};
			const targetKeys = getKeys(target);
			const sourceKeys = getKeys(source);
			let i, il, key;
			for (i = 0, il = targetKeys.length; i < il; ++i) isNotPrototypeKey(key = targetKeys[i]) && sourceKeys.indexOf(key) === -1 && (result[key] = clone(target[key]));
			for (i = 0, il = sourceKeys.length; i < il; ++i) {
				if (!isNotPrototypeKey(key = sourceKeys[i])) continue;
				if (key in target) {
					if (targetKeys.indexOf(key) !== -1) if (cloneProtoObject && isMergeableObject(source[key]) && Object.getPrototypeOf(source[key]) !== JSON_PROTO) result[key] = cloneProtoObject(source[key]);
					else result[key] = _deepmerge$1(target[key], source[key]);
				} else result[key] = clone(source[key]);
			}
			return result;
		}
		function _deepmerge$1(target, source) {
			const sourceIsArray = Array.isArray(source);
			const targetIsArray = Array.isArray(target);
			if (isPrimitive(source)) return source;
			else if (!isMergeableObject(target)) return clone(source);
			else if (sourceIsArray && targetIsArray) return mergeArray(target, source);
			else if (sourceIsArray !== targetIsArray) return clone(source);
			else return mergeObject(target, source);
		}
		function _deepmergeAll() {
			switch (arguments.length) {
				case 0: return {};
				case 1: return clone(arguments[0]);
				case 2: return _deepmerge$1(arguments[0], arguments[1]);
			}
			let result;
			for (let i = 0, il = arguments.length; i < il; ++i) result = _deepmerge$1(result, arguments[i]);
			return result;
		}
		return options?.all ? _deepmergeAll : _deepmerge$1;
	}
	module.exports = deepmergeConstructor;
	module.exports.default = deepmergeConstructor;
	module.exports.deepmerge = deepmergeConstructor;
	Object.defineProperty(module.exports, "isMergeableObject", { get: defaultIsMergeableObjectFactory });
}) });

//#endregion
//#region src/deepmerge.ts
var import_deepmerge = /* @__PURE__ */ __toESM(require_deepmerge());
/**
* Deeply merges two objects together. Works great for `as const` objects.
*
* The return type is very purposefully designed to create a union type that is the sum of both objects.
*
* @category Objects
*
* @example
* ```ts twoslash
* import { deepmerge } from '@simplisafe/ewok'
*
* const result_1 = deepmerge({a: 'value'}, { b: 404 })
* //     ^?
*
* const result_2 = deepmerge({ a: ['one'] } as const, { a: ['two'] } as const)
* //     ^?
*
* const a = { foo: 123, a: { b: 'one', one: 'foo' } } as const
* const b = { bar: 'hello', a: { b: 'two', two: 'foo' } } as const
*
* const result_3 = deepmerge(a, b)
* //      ^?
*
* const result_4 = deepmerge({ a: 42 }, { a: "foo"})
* //      ^?
* ```
*
* This is great for when you want to combine language files into one object and maintain fallbacks with strong types.
*
* @example
* ```ts twoslash ignore
* // @noErrors
* import { deepmerge } from '@simplisafe/ewok'
*
* const us = {
*     test: { 'us-only': 'Hello US!', 'locale': 'en-US', array: ['one'], greeting: "Howdy!", game: "Baseball" },
* } as const
*
* const uk = {
*     test: { 'uk-only': 'Hello UK!', 'locale': 'en-GB', array: ['two'], greeting: "Cheers!", game: "Cricket" },
* } as const
*
* const values = {
*     'en-US': deepmerge(uk, us),
*     'en-GB': deepmerge(us, uk)
* }
*
* const game = values['en-GB'].test.game
* //     ^?
* ```
*/
function deepmerge(x, y) {
	return (0, import_deepmerge.default)({
		all: true,
		mergeArray: (options) => {
			const clone = options.clone;
			return function(target, source) {
				if (source.length) return clone(source);
				return clone(target) || [];
			};
		}
	})(x, y);
}

//#endregion
export { deepmerge };